export const PL_COMMIT = 'PL_Commit';
export const QUARTER_INFO = 'QUARTER_INFO';
export const GCSP_QUARTER_INFO = 'GCSP_QUARTER_INFO';
export const MSL_QUARTER_INFO = 'MSL_QUARTER_INFO';
export const YEAR_WISE_DATA = 'YEAR_WISE_DATA';
export const QUARTERLY_OP_DETAILS = 'QUARTERLY_OP_DETAILS';
export const MODAL_TRIGGER = 'MODAL_TRIGGER';
export const PRIVACY_MODAL = 'PRIVACY_MODAL';
export const PL_OPPS_DETAILS_MODAL = 'PL_OPPS_DETAILS_MODAL';
export const GCSP_OPPS_DETAILS_MODAL = 'GCSP_OPPS_DETAILS_MODAL';
export const PL_COMMENT_MODAL = 'PL_COMMENT_MODAL';
export const GCSP_COMMENT_MODAL = 'GCSP_COMMENT_MODAL';
export const PL_OPPS_NAME_DETAILS_WARNING_MODAL = 'PL_OPPS_NAME_DETAILS_WARNING_MODAL';
export const GCSP_OPPS_DETAILS_WARNING_MODAL = 'GCSP_OPPS_DETAILS_WARNING_MODAL';
export const PL_COMMENT_WARNING_MODAL = 'PL_COMMENT_WARNING_MODAL';
export const GCSP_COMMENT_WARNING_MODAL = 'GCSP_COMMENT_WARNING_MODAL';
export const PL_SUBMIT_SUCCESS_MODAL = 'PL_SUBMIT_SUCCESS_MODAL';
export const PL_FAILURE_CONFIRMATION_MODAL = 'PL_FAILURE_CONFIRMATION_MODAL';
export const GCSP_OPP_VIEW = 'GCSP_OPP_VIEW';
export const MSL_OPP_VIEW = 'MSL_OPP_VIEW';
export const RECOIL_SELECTED_ACCOUNT_STATE = 'RECOIL_SELECTED_ACCOUNT_STATE';
export const CURRENT_USER = 'CURRENT_USER';
export const ACCOUNT_LIST = 'ACCOUNT_LIST';
export const GCSP_ACTIVE_TAB_STATE = 'GCSP_ACTIVE_TAB_STATE';
export const ACTIVE_TAB_GCSP = 'ACTIVE_TAB_GCSP';
export const RECOIL_ALL_ACCOUNTS_QUARTER_STATE = 'RECOIL_ALL_ACCOUNTS_QUARTER_STATE';
export const GCSP_PAST_OPP_VIEW = 'GCSP_PAST_OPP_VIEW';
export const PURSUIT_LEADER_TABLE_ROW_DATA = 'PURSUIT_LEADER_TABLE_ROW_DATA';
export const DASHBOARD_PROFILE_DETAILS = 'DASHBOARD_PROFILE_DETAILS';
export const SUMMARY_DRAWER_TOGGLE = 'SUMMARY_DRAWER_TOGGLE';
export const SYSTEM_DATE_TIME = 'SYSTEM_DATE_TIME';
export const NOW_NEXT_BEYOND_SIDEBAR_DATA_STATE = 'NOW_NEXT_BEYOND_SIDEBAR_DATA_STATE';
export const ALL_MONTH_DATA = 'ALL_MONTH_DATA';
export const ALL_MONTH_MSL_DATA = 'ALL_MONTH_MSL_DATA';
export const NEXT_BUTTON_ACTIVE = 'NEXT_BUTTON_ACTIVE';
export const OPERATING_SYSTEM = 'OPERATING_SYSTEM';
export const REFRESH_PL_SIDEBAR_DATA = 'REFRESH_PL_SIDEBAR_DATA';
export const TRIGGER_UPDATE_PL_SIDEBAR_DATA = 'TRIGGER_UPDATE_PL_SIDEBAR_DATA';
export const PL_SIDEBAR_UPDATE_OPP_PAYLOAD = 'PL_SIDEBAR_UPDATE_OPP_PAYLOAD';
export const SIDEBAR_EXPAND_COLLAPSE_STATE = 'SIDEBAR_EXPAND_COLLAPSE_STATE';
export const LOADING_MODAL_STATE = 'LOADING_MODAL_STATE';
export const IS_BADDATA_AVAILABLE = 'IS_BADDATA_AVAILABLE';
export const REFRESH_PL_FORECAST_PAGE = 'REFRESH_PL_FORECAST_PAGE';
export const CURRENT_PAGE_NAME = 'CURRENT_PAGE_NAME';
export const FULL_PAGE_LOADING_STATE = 'FULL_PAGE_LOADING_STATE';
export const IS_READ_ONLY_STATE = 'IS_READ_ONLY_STATE';
export const SHOW_REFRESH_BUTTON_STATE = 'SHOW_REFRESH_BUTTON_STATE';
export const COUNTRY_NAME_STATE = 'COUNTRY_NAME_STATE';
export const IS_USER_AVAILABLE_STATE = 'IS_USER_AVAILABLE_STATE';
export const FLATTENED_ACCOUNT_LIST_STATE = 'FLATTENED_ACCOUNT_LIST_STATE';
export const REFRESH_PILLS_STATUS_STATE = 'REFRESH_PILLS_STATUS_STATE';
export const REFRESH_ALERT_BAR_STATE = 'REFRESH_ALERT_BAR_STATE';
export const IS_OPPS_BAD_DATA_AVAILABLE_STATE = 'IS_OPPS_BAD_DATA_AVAILABLE_STATE';
export const MSL_OPPORTUNITY_STATE = 'MSL_OPPORTUNITY_STATE';
export const REFRESH_AUTH_TOKEN = 'REFRESH_AUTH_TOKEN';
export const MSL_QUARTER_STATE_INFO = 'MSL_QUARTER_STATE_INFO';
export const SUBMISSION_FAILURE = 'SUBMISSION_FAILURE';
export const OPEN_SUPER_USER_MODAL_STATE = 'OPEN_SUPER_USER_MODAL_STATE';
export const MESSAGE_MODAL_STATE = 'MESSAGE_MODAL_STATE';
export const IS_MSL_DELEGATE = 'IS_MSL_DELEGATE';
